import React from "react";
import { Card, CardContent, CardHeader } from "../ui/card";

/*
 * Placeholder with the shape of a dashboard widget, shown while its data loads, so the
 * layout appears at once and each widget fills in when its request finishes.
 *   variant "stat":  live value card (title + round gauge)
 *   variant "chart": history chart card (title + subtitle + plot area)
 */
export default function WidgetSkeleton({ variant = "stat" }) {
  return (
    <Card className="widget-skeleton" aria-busy="true" aria-label="Loading">
      {variant === "chart" ? (
        <>
          <CardHeader className="gap-2 border-b">
            <div className="skeleton-block h-5 w-56 max-w-full" />
            <div className="skeleton-block h-4 w-80 max-w-full" />
          </CardHeader>
          <CardContent className="pt-6">
            <div className="skeleton-block h-[250px] w-full" />
          </CardContent>
        </>
      ) : (
        <>
          <CardHeader className="items-center gap-2">
            <div className="skeleton-block h-5 w-40 max-w-full" />
          </CardHeader>
          <CardContent className="flex flex-col items-center gap-4">
            <div className="skeleton-block h-40 w-40 rounded-full" />
            <div className="skeleton-block h-4 w-48 max-w-full" />
          </CardContent>
        </>
      )}
    </Card>
  );
}
